import { Component } from '@angular/core';
import { CognitoAuthService } from '@techspert-io/auth';

@Component({
  selector: 'app-private',
  templateUrl: './private.component.html',
  styleUrls: ['./private.component.scss'],
})
export class PrivateComponent {
  constructor(public cognitoAuthService: CognitoAuthService) {}
}
